import styled from 'styled-components';

import { media } from '../../../styles/constants';
import { padding } from '../../../styles/padding';

const ImageAndPhoneContainer = styled.div`
  display: flex;
  height: 100%;
  margin-top: 3rem;
  margin-bottom: 22rem;
  position: relative;

  img {
    width: 100%;
    height: auto;
  }

  > div:first-child {
    width: 38%;
    max-width: 20rem;
    padding-left: ${padding.smallPhone.horizontal};
  }

  > div:last-child {
    width: 95%;
    max-width: 48rem;
    position: absolute;
    right: -4rem;
    top: -2rem;
  }

  @media (min-width: ${media.phone}) {
    margin-bottom: 30rem;
    > div:first-child {
      padding-left: ${padding.phone.horizontal};
    }
  }

  @media (min-width: ${media.tabletPortrait}) {
    margin-top: 7rem;

    > div:first-child {
      padding-left: 4.5rem;
      width: 26%;
    }

    > div:last-child {
      right: 0;
      padding-right: ${padding.tabletPortrait.horizontal};
      top: 0;
    }
  }

  @media (min-width: ${media.tabletLandscape}) {
    margin-top: 5rem;
    margin-bottom: 20rem;

    > div:first-child {
      margin-top: -1rem;
    }

    > div:last-child {
      margin-top: -20%;
      padding-right: 2rem;
    }
  }

  @media (min-width: ${media.desktop}) {
    margin-top: 14rem;

    > div:first-child {
      padding-left: 6.5rem;
      max-width: 27rem;
      margin-top: -8rem;
    }

    > div:last-child {
      padding-right: 0;
      right: -7rem;
      max-width: 53rem;
    }
  }

  @media (min-width: ${media.bigDesktop}) {
    margin-top: 25rem;

    > div:first-child {
      padding-left: 7.5rem;
      width: 34%;
      max-width: 55rem;
      margin-top: -18rem;
    }

    > div:last-child {
      max-width: 62rem;
      right: -28rem;
    }
  }
`;

export default ImageAndPhoneContainer;
